export const MAX_SUBSCRIPTION_RETRIES = 3;

const RETRY_BACKOFF_STEP_MS = 1000;

// linear backoff: the first re-attach waits 1s, the second 2s, the third 3s
export const getSubscriptionRetryDelayMs = (attempt: number): number =>
  RETRY_BACKOFF_STEP_MS * attempt;
